import { Check } from "@phosphor-icons/react";
import clsx from "clsx";

import type { SubscriptionType } from "common/types";

export default function SubscriptionCard({ type }: { type: SubscriptionType }) {
  const isUserSubscription = type === "user";

  return (
    <article
      className={clsx(
        "flex flex-col justify-between bg-cover bg-center h-[390px] p-4 lg:w-[381px] rounded-5xl lg:border-4 border-black-200 lg:shadow-2xl",
        isUserSubscription
          ? "bg-[url(/images/outreach-seat.png)]"
          : "bg-[url(/images/outreach-avatar.png)]",
      )}
    >
      <span
        className={clsx(
          "inline-flex text-white text-xxs px-1.5 rounded-full border border-[#DCE1EA] self-start",
          isUserSubscription
            ? "bg-[linear-gradient(333deg,_rgba(255,_255,_255,_0.70)_-2.24%,_rgba(255,_255,_255,_0.00)_39.05%)]"
            : "shadow-[0_-0.889px_4.267px_-1.334px_#FFF_inset,_0_0_4.267px_-1.334px_#FFF_inset,_0_0_10.446px_0_#3700FF_inset]",
        )}
      >
        {isUserSubscription ? "$39 /mo per seat" : "$99 /mo per account"}
      </span>

      <div className="p-4 flex flex-col gap-y-3 border border-white/70 rounded-3xl backdrop-blur-sm">
        <div className="flex flex-col gap-y-1.5">
          <h3 className="text-white text-xs-bold">
            {isUserSubscription
              ? "Use your own LinkedIn account"
              : "Rent a LinkedIn account"}
          </h3>
          <p className="text-xxs text-black-200">
            {isUserSubscription
              ? "Connect your own or your client's LinkedIn account and send unlimited campaigns targeted at your prospects"
              : "Rent fully customizable LinkedIn accounts to scale your LI outreach. Every account comes with an Outreach Seat"}
          </p>
        </div>

        <ul className="text-white text-xxs flex flex-col gap-y-2 [&>li]:flex [&>li]:gap-x-1 [&>li]:items-center [&>li>span]:text-xxs-bold [&>li>svg]:size-3">
          {isUserSubscription ? (
            <>
              <li>
                <Check />
                <span>Connect</span> with the right people
              </li>
              <li>
                <Check />
                <span>Engage</span> them in meaningful conversations
              </li>
              <li>
                <Check />
                <span>Scale</span> your LinkedIn outreach
              </li>
              <li>
                <Check />
                All while <span>staying safe</span>
              </li>
            </>
          ) : (
            <>
              <li>
                <Check />
                Includes <span>Outreach Seat</span>
              </li>
              <li>
                <Check />
                <span>Customize</span> every Avatar account
              </li>
              <li>
                <Check />
                <span>1-3 day delivery</span> straight to your workspace
              </li>
              <li>
                <Check />
                Full <span>Replacement guarantee</span>
              </li>
            </>
          )}
        </ul>
      </div>
    </article>
  );
}
